import React, {useState, useEffect} from 'react';
import './style.scss';
import { Route, useParams } from 'react-router-dom';
import Wrapper from '../../templates/Wrapper/Wrapper';
import MobileOrderBanner from '../../components/MobileOrderBanner/MobileOrderBanner';
import Beef from './OurFoodPages/Beef/Beef';
import Chicken from './OurFoodPages/Chicken/Chicken';
import Eggs from './OurFoodPages/Eggs/Eggs';
import Pork from './OurFoodPages/Pork/Pork';
import BeyondMeat from './OurFoodPages/BeyondMeat/BeyondMeat';
import Tomatoes from './OurFoodPages/Tomatoes/Tomatoes';
import Onions from './OurFoodPages/Onions/Onions';
import Lettuce from './OurFoodPages/Lettuce/Lettuce';
import Cheese from './OurFoodPages/Cheese/Cheese';
import RootBeer from './OurFoodPages/RootBeer/RootBeer';
import Coffee from './OurFoodPages/Coffee/Coffee';
import AnimalWelfare from './OurFoodPages/AnimalWelfare/AnimalWelfare';
import HomeOurFood from './OurFoodPages/HomeOurFood/HomeOurFood';

import './style.scss';

const OurFood = (props) => {

    const [activePage, setActivePage] = useState('');
    const params = useParams();

    useEffect(() => {
        //console.log('Our Food ',params);
        setActivePage(params.category);
        window.scroll(0,0);
    },[params])
    
    return (

        <Wrapper addClass="our-food" {...props} exploreMenu={true} exploreMenuCat="our-food" activePage={activePage}>

            {!params.category && 
                <>
                <Route  path="/:lang/our-values/our-food"  component={() => <HomeOurFood {...props} />} /> 
                <MobileOrderBanner lang={props.lang} />
                </>
            }

            <Route  path="/:lang/our-values/our-food/beef"  component={() => <Beef {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/chicken"  component={() => <Chicken {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/eggs"  component={() => <Eggs {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/pork"  component={() => <Pork {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/beyond-meat"  component={() => <BeyondMeat {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/tomatoes"  component={() => <Tomatoes {...props} />} />
            <Route  path="/:lang/our-values/our-food/onions"  component={() => <Onions {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/lettuce"  component={() => <Lettuce {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/cheese"  component={() => <Cheese {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/rootbeer"  component={() => <RootBeer {...props} />} /> 
            <Route  path="/:lang/our-values/our-food/coffee"  component={() => <Coffee {...props} />} />
            <Route  path="/:lang/our-values/our-food/animal-welfare"  component={() => <AnimalWelfare {...props} />} /> 
            {/* <MobileOrderBanner lang={props.lang} /> */}
        </Wrapper>

    )
}

export default OurFood;